import {call, put} from "typed-redux-saga";
import {Api, ApiError} from "modules/utils";
import {
	requestUserAchievementsFailed,
	requestUserAchievementsSuccess,
	showErrorModal,
} from "modules/actions";

export const requestUserAchievementsSaga = function* () {
	try {
		const result = yield* call(Api.Achievements.get);
		yield* put(requestUserAchievementsSuccess(result.success.achievements));
	} catch (err) {
		yield* put(requestUserAchievementsFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};
